import { VisibilityTypeMenuOption } from "./types";

export const inputSpacing = 4;

export const visibilityTypes: VisibilityTypeMenuOption[] = [
  { id: "public", translationKey: "visibilityPublic" },
  { id: "private", translationKey: "visibilityPrivate" },
];
